import apiClient from '../../services/axios';
import { normalizeApiError } from '../../services/normalizeError';

const configHeaders = { headers: { 'Authorization': `Bearer ${localStorage.xToken}` } }
const configFileHeaders = {
  responseType: 'blob',
  headers: {
    'Authorization': `Bearer ${localStorage.xToken}`,
    'Content-Type': 'application/pdf',
  },
};

export function buildQueryParameters(searchText, limit = 10, page = 0) {
  return `?limit=${limit}&page=${page}&search=${searchText.value}`
}

export async function get(path) {
  return await apiClient.get(path, configHeaders).catch(err => { throw normalizeApiError(err) })
}

export async function post(path, data) {
  return await apiClient.post(path, data, configHeaders).catch(err => { throw normalizeApiError(err) })
}

export async function postFile(path, data) {
  return await apiClient.post(path, data, configFileHeaders).catch(err => { throw normalizeApiError(err) })
}

export async function update(path, id, data) {
  return await apiClient.patch(path + '/' + id, data, configHeaders).catch(err => { throw normalizeApiError(err) })
}

export async function softDelete(path, id) {
  return await apiClient.delete(path + '/' + id, configHeaders).catch(err => { throw normalizeApiError(err) })
}
